export default __webpack_public_path__ + "media/images/partnerships/slide-3-nvidia.jpg";